module.exports = __webpack_public_path__ + "static/img/hall-bg.0fe7cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/developerConference/hall-bg.png
// module id = 0ESx
// module chunks = 86